<template>
<div class="view--reward">
  <header class="header">
    <div class="containter">
      <div class="row justify-content-center">
        <div class="col col-md-6 col-lg-4">
          <div class="nav">
            <router-link :to="{ name: 'Point', params: { token: $route.params.pointToken } }" tag="div" class="back">
              <i class="material-icons icon">chevron_left</i>
            </router-link>
            <h1 class="title">{{ $t('reward.title') }}</h1>
            <div class="placeholder"></div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <main v-cloak>
    <div class="containter">
      <div class="row no-gutters justify-content-center">
        <div class="col col-md-6 col-lg-4">
          <div class="fig" :style="'background-image: url(' + reward.image + ')'">
            <div class="name">{{ reward.name }}</div>
            <div class="require">
              <span class="amount">{{ reward.require | properNumber }}</span>
              {{ point.type === 'DEPOSIT' ? $tc('points.dollars',
                { points: $options.filters.properNumber(reward.require) }) : $tc('points.points',
                { points: $options.filters.properNumber(reward.require) })
              }}
            </div>
          </div>
          <div class="sub-title">{{ $t('reward.content') }}</div>
          <div class="desc" v-html="reward.desc" v-linkified></div>
          <div class="info" v-if="'remain' in reward">
            {{ $tc('reward.remain', reward.require,
              { count: reward.remain.toLocaleString() })
            }}
          </div>
        </div>
      </div>
    </div>
    <i18n-picker></i18n-picker>
  </main>
  <footer class="footer" v-if="!reward.redeemViaOboss">
    <div class="containter">
      <div class="row justify-content-center">
        <div class="col col-md-6 col-lg-4">
          <button
            class="btn"
            :class="{ 'btn-loading': rewardRedeemLoading }"
            v-on:click="redeem()"
          >
            {{ $t('reward.redeem') }}
            <div class="btn-loader"><span></span><span></span><span></span></div>
          </button>
        </div>
      </div>
    </div>
  </footer>
  <div class="background">
    <div class="image" :style="'background-image: url(' + brand.image + ')'"></div>
    <div class="overlay"></div>
  </div>

  <barcode
    :visable="barcode"
    :value="reward.barcode.value"
    :format="reward.barcode.format"
    :title="$t('barcode.redeemRewardViaBarcode')"
    :name="reward.name"
    :qrcode="true"
    :cell="user.cellFormated"
    v-on:toggleBarcode="redeemViaBarcode()"
    :barcodeTime="reward.barcode.time"
  >
  </barcode>
  <ultrasound
    v-if="reward.ultrasound"
    :visable="ultrasound"
    :ultrasound-playing="ultrasoundPlaying"
    v-on:toggleUltrasound="toggleUltrasound">
  </ultrasound>
  <div class="qrcode-reader" v-if="showQrcodeReader">
    <svg class="qrcode-box" width="674px" height="674px" viewBox="0 0 674 674" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Shape</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
            <path d="M7,181.344194 C7,120.720919 13.3121416,98.7374551 25.1650239,76.5744922 C37.0179062,54.4115292 54.4115292,37.0179062 76.5744922,25.1650239 C98.7374551,13.3121416 120.720919,7 181.344194,7 M492.655806,7 C553.279081,7 575.262545,13.3121416 597.425508,25.1650239 C619.588471,37.0179062 636.982094,54.4115292 648.834976,76.5744922 C660.687858,98.7374551 667,120.720919 667,181.344194 M667,492.655806 C667,553.279081 660.687858,575.262545 648.834976,597.425508 C636.982094,619.588471 619.588471,636.982094 597.425508,648.834976 C575.262545,660.687858 553.279081,667 492.655806,667 M181.344194,667 C120.720919,667 98.7374551,660.687858 76.5744922,648.834976 C54.4115292,636.982094 37.0179062,619.588471 25.1650239,597.425508 C13.3121416,575.262545 7,553.279081 7,492.655806" id="Shape" stroke="#FFFFFF" stroke-width="14"></path>
        </g>
    </svg>
    <button class="qrcode-reader-close" v-on:click="showQrcodeReader = false">{{ $t('common.close') }}</button>
    <qrcode-stream v-on:decode="redeemViaQrcode" v-on:init="qrcodeReaderInit" />
  </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { Howl } from 'howler';
import swal from 'sweetalert2';
import linkify from 'vue-linkify';
import { QrcodeStream } from 'vue-qrcode-reader';

import Axios from '@/helpers/axios';

import Barcode from '@/components/Barcode.vue';
import Ultrasound from '@/components/Ultrasound.vue';
import I18nPicker from '@/components/I18nPicker.vue';

export default {
  data() {
    return {
      barcode: false,
      ultrasound: false,
      ultrasoundPlaying: false,
      amount: 100,

      qrcodeRedeemAmount: 0,

      showQrcodeReader: false,
      rewardRedeemLoading: false,
    };
  },
  computed: {
    ...mapState([
      'user',
      'brand',
      'client',
      'card',
      'point',
      'reward',
    ]),
    ultrasoundInstance() {
      if (this.reward.ultrasound) {
        return new Howl({ src: this.reward.ultrasound, loop: true });
      }
      return null;
    },
  },
  name: 'Reward',
  beforeMount() {
    if (this.reward.token !== this.$route.params.token) {
      this.$router.replace({ name: 'Point' });
    }
  },
  methods: {
    ...mapMutations([
      'setLoader',
    ]),
    toggleUltrasound() {
      this.ultrasoundInstance.once('play', () => {
        this.ultrasoundPlaying = true;

        this.$gtm.trackEvent({
          event: '使用集點音波感應',
          label: `${this.$root.$store.state.brand.name} - ${this.reward.name}`,
        });
      });

      this.ultrasoundInstance.once('stop', () => {
        this.ultrasoundPlaying = false;
      });

      if (!this.ultrasound) {
        this.ultrasoundInstance.play();
      } else {
        this.ultrasoundInstance.stop();
      }

      this.ultrasound = !this.ultrasound;
    },
    redeem() {
      if (this.point.point < this.reward.require) {
        swal.fire({
          text: this.$i18n.t('reward.lack'),
          confirmButtonText: this.$i18n.t('common.back'),
        });
        return;
      }

      this.$gtm.trackEvent({
        event: '兌換集點',
        label: `${this.$root.$store.state.brand.name} - ${this.reward.name}`,
      });

      if (this.reward.redeemViaBarcode) {
        this.redeemViaBarcode();
      } else if (this.reward.redeemViaUltrasound) {
        this.toggleUltrasound();
      } else if (this.reward.multiRedeem) {
        this.redeemViaPoints();
      } else {
        this.confirmRedeemViaPoints(1);
      }
    },
    redeemViaPoints() {
      swal.fire({
        text: this.$i18n.t('reward.amount'),
        input: 'text',
        inputPlaceholder: this.$i18n.t('reward.amountPlaceholder'),
        inputAttributes: {
          pattern: '[0-9]*',
        },
        confirmButtonText: this.$i18n.t('common.next'),
        showCancelButton: true,
        cancelButtonText: this.$i18n.t('common.cancel'),
        reverseButtons: true,
      }).then((redeemAmount) => {
        const amount = redeemAmount.value === '' ? 1 : redeemAmount.value;

        if (Number.isInteger(Number(amount)) && Number(amount) > 0) {
          this.confirmRedeemViaPoints(amount);
        } else if (amount) {
          swal.fire({
            text: this.$i18n.t('reward.amountIncorrect'),
            confirmButtonText: this.$i18n.t('common.back'),
          });
        }
      });
    },
    confirmRedeemViaPoints(amount) {
      if (this.point.point >= Number(this.reward.require * amount)) {
        const confirmText = this.reward.redeemViaOnline ? `${this.$i18n.tc('reward.confirm2', this.reward.require * amount, { points: this.$options.filters.properNumber(this.reward.require * amount) })} ${this.$i18n.tc('reward.confirm3', amount, { amount: this.$options.filters.properNumber(amount) })} ${this.$i18n.t('reward.confirm4', { reward: this.reward.name })}` : `${this.$i18n.tc('reward.confirm1', this.reward.require * amount, { points: this.$options.filters.properNumber(this.reward.require * amount) })} ${this.$i18n.tc('reward.confirm3', amount, { amount: this.$options.filters.properNumber(amount) })} ${this.$i18n.t('reward.confirm4', { reward: this.reward.name })}`;
        swal.fire({
          text: confirmText,
          confirmButtonText: this.$i18n.t('reward.redeem'),
          showCancelButton: true,
          cancelButtonText: this.$i18n.t('common.cancel'),
          reverseButtons: true,
        })
          .then((redeem) => {
            this.rewardRedeemLoading = true;
            if (redeem.value) {
              if (!this.reward.redeemViaOnline) {
                swal.fire({
                  text: this.$i18n.t('reward.storePIN', { reward: this.reward.name, amount: this.$options.filters.properNumber(amount) }),
                  confirmButtonText: this.$i18n.t('common.ok'),
                  showCancelButton: true,
                  cancelButtonText: this.$i18n.t('common.cancel'),
                  showDenyButton: true,
                  denyButtonText: this.$i18n.t('common.scan'),
                  reverseButtons: true,
                  input: 'password',
                  inputAttributes: {
                    autocomplete: 'off',
                    autocapitalize: 'off',
                    autocorrect: 'off',
                    spellcheck: 'false',
                  },
                })
                  .then((redeemCode) => {
                    if (redeemCode.isDenied) {
                      this.qrcodeRedeemAmount = amount;
                      this.showQrcodeReader = true;
                    }

                    if (redeemCode.value) {
                      this.redeemReward(this.reward.token, amount, redeemCode.value);
                    }
                  });
              } else {
                this.redeemReward(this.reward.token, amount);
              }
            }
          });
      } else {
        // 剩餘點數不足
        swal.fire({
          text: `${this.$i18n.tc('reward.lessAmount1', amount, { amount: this.$options.filters.properNumber(amount) })} ${this.$i18n.tc('reward.lessAmount2', this.reward.require * amount, { reward: this.reward.name, points: this.$options.filters.properNumber(this.reward.require * amount) })} \n${this.$i18n.tc('reward.lessAmount3', this.point.point, { userPoints: this.$options.filters.properNumber(this.point.point) })}`,
          confirmButtonText: this.$i18n.t('common.back'),
        });
      }
    },
    redeemReward(gift, amount = 1, redeemCode = null) {
      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
        _gift: gift,
        count: amount,
      };

      if (redeemCode) data.redeem_code = redeemCode;

      Axios({
        method: 'post',
        url: '/point/redeem',
        data,
      })
        .then((response) => {
          if (response.data.code === 500) {
            // 舊版兌換項目 response 可能無 action 欄位，需先判斷是否存在避免出錯
            const hasAction = Object.prototype.hasOwnProperty.call(response.data.data, 'action');

            swal.fire({
              text: response.data.data.msg,
              confirmButtonText: this.$i18n.t('common.ok'),
              // 有 action 才顯示「查看」按鈕
              showDenyButton: hasAction,
              denyButtonText: this.$i18n.t('common.view'),
              reverseButtons: false,
            })
              .then((result) => {
                if (!result.isDenied) return;

                switch (response.data.data.action) {
                  case 'COUPON':
                    this.$router.push({ name: 'Coupons' });
                    break;
                  case 'DRAW':
                    this.$router.push({ name: 'Gifts' });
                    break;
                  case 'VIP':
                    this.$router.push({ name: 'Index' });
                    break;
                  default:
                    break;
                }
              });
          } else if (response.data.code === 495) {
            swal.fire({
              text: response.data.msg,
              confirmButtonText: this.$i18n.t('common.back'),
            });
          }
          this.rewardRedeemLoading = false;
        });
    },
    async qrcodeReaderInit(promise) {
      try {
        await promise;
      } catch (error) {
        let errorMsg;

        if (error.name === 'NotAllowedError') {
          errorMsg = this.$i18n.t('common.notAllowedCameraError');
        } else if (error.name === 'NotFoundError') {
          errorMsg = this.$i18n.t('common.notFoundCameraError');
        } else if (error.name === 'NotSupportedError') {
          errorMsg = this.$i18n.t('common.notSupportedNetworkError');
        } else if (error.name === 'NotReadableError') {
          errorMsg = this.$i18n.t('common.notReadableCameraError');
        } else if (error.name === 'StreamApiNotSupportedError') {
          errorMsg = this.$i18n.t('common.streamApiNotSupportedError');
        } else if (error.name === 'InsecureContextError') {
          errorMsg = this.$i18n.t('common.notSupportedNetworkError');
        } else {
          errorMsg = this.$i18n.t('common.unableAccessCameraError');
        }

        this.showQrcodeReader = false;

        let errorText = '';
        if (this.$i18n.locale === 'zh-Hant') {
          errorText = `${errorMsg}，${this.$i18n.t('common.unableScanError')}`;
        } else if (this.$i18n.locale === 'en' || this.$i18n.locale === 'vi' || this.$i18n.locale === 'th') {
          errorText = `${errorMsg} ${this.$i18n.t('common.unableScanError')}`;
        } else {
          errorText = errorMsg;
        }


        swal.fire({
          text: errorText,
        });
      }
    },
    redeemViaQrcode(result) {
      this.redeemReward(this.reward.token, this.qrcodeRedeemAmount, result);

      this.showQrcodeReader = false;
    },
    redeemViaBarcode() {
      this.barcode = !this.barcode;
    },
  },
  components: {
    Barcode,
    Ultrasound,
    I18nPicker,
    QrcodeStream,
  },
  mounted() {
    this.setLoader(false);
  },
  directives: {
    linkified: linkify,
  },
};
</script>

<style lang="sass" scoped>
.view--reward
  width: 100%
  height: 100%
  position: relative

  color: white

.background
  position: fixed
  width: 100%
  width: 100vw
  height: 100%
  height: 100vh
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: -1

  .overlay,
  .image
    position: absolute
    top: -10px
    right: -10px
    bottom: -10px
    left: -10px

    background-color: rgba(0, 0, 0, .45)

    background-size: cover
    background-position: center

  .overlay
    -webkit-backdrop-filter: saturate(150%)

  .image
    filter: blur(10px)

.header
  position: fixed
  top: 0
  right: 0
  left: 0
  padding: 12px
  z-index: 1020

  background-color: rgba(0, 0, 0, .25)

  color: white
  text-shadow: 0 1px 2px rgba(0, 0, 0, .5)

  @supports (-webkit-backdrop-filter: blur(15px))
    box-shadow: 0 2px 5px rgba(0, 0, 0, .25)

    -webkit-backdrop-filter: blur(15px)
    background-color: rgba(0, 0, 0, .1)

  .nav
    display: flex

  .back
    height: 24px

    cursor: pointer

    .icon
      width: 36px
      height: 36px

      font-size: 2.25rem
      line-height: 1

  .title
    flex-grow: 1
    margin: 3px 0

    font-size: 1.2081rem
    font-weight: bold
    text-align: center
    line-height: 28px

  .placeholder
    width: 36px

main
  padding: 60px 0 80px

  .fig
    position: relative
    margin: 24px
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .5)

    border-radius: 16px

    background-size: cover
    background-repeat: no-repeat
    background-position: center

    &::before
      display: block
      padding-top: 100%
      z-index: -1

      border-radius: 16px

      background-image: linear-gradient(-180deg, #333333 0%, rgba(51, 51, 51, .15) 20%, rgba(51, 51, 51, .15) 80%, #333333 100%)

      content: ''

  .name
    position: absolute
    top: 24px
    right: 24px
    left: 24px

    font-size: 1.5rem
    font-weight: bold

  .require
    position: absolute
    right: 24px
    bottom: 24px
    left: 24px

    font-size: 1.2081rem
    font-weight: bold
    text-align: right
    line-height: 1

    .amount
      margin-right: 2px
      display: inline-block

      font-size: 3rem
      font-weight: 300

  .sub-title
    padding: 0 24px
    margin: 20px 0 10px

    font-weight: bold
    font-size: 0.875rem
    letter-spacing: 2px
    color: rgba(255, 255, 255, .75)
    text-transform: uppercase

  .desc,
  .comment
    margin: 8px 0 24px
    padding: 0 16px
    white-space: pre-wrap

    font-size: 0.875rem
    line-height: 1.6

    ::v-deep .linkified
      color: white
      text-decoration: underline

  .info
    font-size: 0.75rem
    color: rgba(255, 255, 255, .5)
    text-align: center

.footer
  position: fixed
  right: 0
  bottom: 0
  left: 0
  padding: 12px
  z-index: 1020

  text-align: center

  .btn
    padding: 10px
    display: block
    width: 100%

    border-radius: 99px

    background-color: #ffea00

    color: #333
    font-weight: bold
    font-size: 1.125em

    &:active
      opacity: .5

      transform: scale(.95)
    &.btn-loading
      pointer-events: none

      .btn-loader
        display: block

    .btn-loader
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      border-radius: 99px
      display: none

      background-color: inherit

      &.inverse
        span
          background-color: white

      span
        display: inline-block
        width: 10px
        height: 10px
        border-radius: 100%
        background-color: #575757
        margin: 18px 5px
        opacity: 0

        &:nth-child(1)
          animation: opacitychange .5s ease-in-out infinite

        &:nth-child(2)
          animation: opacitychange .5s ease-in-out .166666667s infinite

        &:nth-child(3)
          animation: opacitychange .5s ease-in-out .333333334s infinite

        @keyframes opacitychange
          0%, 100%
            opacity: 0

          60%
            opacity: 1
</style>

<style lang="sass">
$cb: cubic-bezier(.4, 0, .2, 1)

.stepper
  user-select: none
  text-align: center

  &__minus,
  &__plus
    display: inline-block
    padding: 0
    width: 50px
    height: 50px

    border-radius: 99px

    background-color: #3F51B5

    vertical-align: middle
    color: white
    cursor: pointer

    .material-icons
      line-height: 50px

  &__count
    margin-right: 1px
    display: inline-block
    padding: 10px 20px

    text-align: center
    font-weight: bold
    vertical-align: middle

  &__number
    display: inline-block
    width: 100%
    box-shadow: none

    border: none
    border-radius: 10px

    background-color: #eee

    text-align: center
    font-size: 2.625rem
    font-weight: 300
    line-height: 1.5

  &__unit
    display: inline-block

    font-weight: bold
    font-size: 0.75rem
    color: #616161

  &__label
    font-weight: bold
    font-size: 0.75rem
    color: #333

.qrcode-reader
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1090
  overflow: hidden

  background: black

  .qrcode-box
    position: fixed
    top: 50%
    right: 0
    bottom: 0
    left: 50%
    width: 50vw
    max-width: 400px
    z-index: 2

    transform: translate(-50%, -50%)

    animation: scale-up-center .75s cubic-bezier(0.390, 0.575, 0.565, 1.000) infinite alternate both;

  .qrcode-reader-close
    position: fixed
    top: auto
    right: auto
    bottom: 5%
    left: 50%
    z-index: 2
    padding: 8px 16px

    border: 0
    border-radius: 10px

    background-color: rgba(0, 0, 0, .25)

    font-weight: bold
    color: white
    font-size: 0.75rem
    text-align: center

    cursor: pointer
    transform: translateX(-50%)

  .qrcode-stream-wrapper
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0

@keyframes scale-up-center
  0%
    transform: translate(-50%, -50%) scale(1)

  100%
    transform: translate(-50%, -50%) scale(1.15)
</style>

